import { createIcon } from '../createIcon';

export const PauseIconConfig = {
  name: 'PauseIcon',
  height: 512,
  width: 320,
  svgPath: 'M48 64C21.5 64 0 85.5 0 112V400c0 26.5 21.5 48 48 48H80c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48H48zm192 0c-26.5 0-48 21.5-48 48V400c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48H240z',
  yOffset: 0,
  xOffset: 0
};

export const PauseIcon = createIcon(PauseIconConfig);

export default PauseIcon;